import { generateKDiagramDataSeries } from "./data_points";
import { generateKDiagramResultSplineSeries } from "./curve";
import { generateKDiagramResultScatterSeries } from "./evaluation_points";
//import { generateKDiagramRangeSeries } from "./range_series";
import { generateShopTestSeries } from "./shop_test_series";
import { generateSeaTrialSeries } from "./sea_trial_series";

export function generateKDiagramChartOptions(
  xAxisTitle,
  yAxisTitle,
  interpolationSeriesName,
  predictionSeriesName,
  rangeSeriesName,
  shoptestSeriesName,
  seaTrialsSeriesName,
  dataSeriesName,
  data,
  interpolationData,
  rangeData,
  shoptestData,
  seaTrialsData,
  predictionData,
  resultsMinRpm,
  resultsMaxRpm,
  reversed = false,
  legendVerticalAlign = "top",
  dataSeriesPointFormat = null,
) {

  const maxSeaTrialsRpm = seaTrialsData ? Math.max(...seaTrialsData.flat().map((item) => item[0])) + 10 : null;
  const maxShoptestRpm = shoptestData ? Math.max(...shoptestData.map((item) => item[0])) + 10 : null;

  const xMax = Math.max(maxSeaTrialsRpm, maxShoptestRpm, resultsMaxRpm);

  const chartOptions = {
    credits: {
      enabled: false,
    },
    time: {
      useUTC: true,
    },
    chart: {
      zoomType: "xy",
    },
    title: {
      text: undefined,
    },
    annotations: [
      {
        labelOptions: {
          shape: "rect",
          verticalAlign: "top",
          align: "right",
          justify: false,
          crop: true,
          backgroundColor: "#FAFAFA",
          borderWidth: 0,
        },
        labels: [],
      },
    ],
    tooltip: {
      shared: true,
    },
    yAxis: {
      title: {
        text: yAxisTitle,
        align: "high",
      },
      reversed: reversed,
      // minorTicks: true
    },
    xAxis: {
      title: {
        text: xAxisTitle,
        align: "high",
      },
      min: resultsMinRpm,
      max: resultsMaxRpm,
      crosshair: true,
      visible: !reversed,
    },
    exporting: {
      enabled: false,
    },
    legend: {
      layout: "horizontal",
      align: "right",
      verticalAlign: legendVerticalAlign,
      floating: false,
    },
    series: [

      // Data Points
      generateKDiagramDataSeries(data, dataSeriesName, dataSeriesPointFormat),
      // Power Curve and Speed Curve
      generateKDiagramResultSplineSeries(interpolationData, interpolationSeriesName, dataSeriesPointFormat),
      // Speed Points, Power Points
      generateKDiagramResultScatterSeries(predictionData, predictionSeriesName, dataSeriesPointFormat),
      // Power Range and Speed Range
      // generateKDiagramRangeSeries(rangeData, rangeSeriesName),
    ],
  };

  const _onLegendItemClick = function () {
    setTimeout(() => {
      const visibiltyStatusAfterClick = this.visible;
      this.chart.xAxis[0].setExtremes(
        resultsMinRpm,
        visibiltyStatusAfterClick ? xMax : resultsMaxRpm
      );
    }, 0);
  };

  if (shoptestData !== null) {
    chartOptions.series.push(generateShopTestSeries(
      shoptestData, shoptestSeriesName, _onLegendItemClick
    ));
  }

  if (seaTrialsData) {
    seaTrialsData.forEach((datum, index) => {
      chartOptions.series.push(generateSeaTrialSeries(
        datum,
        `${seaTrialsSeriesName} ${index + 1}`,
        _onLegendItemClick
      ));
    });
  }

  return chartOptions;
}
